module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customersReference":"Customers reference","consigneeReference":"Consignee reference","addReference":"Add reference"},"no":{"customersReference":"Kundes referanse","consigneeReference":"Mottakers referanse","addReference":"Legg til referanse"}}')
  delete Component.options._Ctor
}
